@if (!isInit) {
  <div class="app-content">
    <span>{{ 'initializeApplication' | translate }}</span>
  </div>
}

@if (isInit) {
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
}

@if (isInit) {
  <app-einrichtung-details></app-einrichtung-details>
}
@if (isInit) {
  <app-remove-account></app-remove-account>
}
@if (isInit) {
  <app-change-password></app-change-password>
}
@if (isInit) {
  <app-error-handler-popup></app-error-handler-popup>
}
